/**
 *
 * FBSectionHeader
 *
 */

import React, { memo, useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';
import { useTranslation} from "react-i18next";

// styles
import './style.scss';

// antd component
import { Button } from 'antd';

// utils
import {
  slugify,
  getUniqueArrayObj,
  getObjId,
} from 'utils/helpers/helper.general';
// custom react-multi-date-picker
import { DateObject } from 'react-multi-date-picker';
import { timeFormat, dateFormat } from 'utils/moment/moment.constant';
import { convertSecondsToTime } from "utils/moment/moment.utils";


function FBExportButton({
  type,
  btnName,
  attachmentData,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-export-wrapper', type, className);
  const { t } = useTranslation();

  const [csvReport, setCsvReport] = useState(false);

  const formatDateTimeValue = useCallback((value, format) => {
    if (!!!value) {
      return '';
    }

    if (typeof value == 'object') {
      const isoDateString = value.toDate().toISOString();
      return !!value && convertSecondsToTime(isoDateString, format);
    } else {
      // Set CET time zone offset manually (in minutes, CET is UTC+1)
      const data = new DateObject(value);
      const isoDateString = data.toDate().toISOString();
      return !!value && convertSecondsToTime(isoDateString, format);
    }

  }, []);

  const generateFormsObjecstFromData = useCallback((dataObject) => {
    if (dataObject && Array.isArray(dataObject) && dataObject?.length > 0) {
      let headersArr = [
       // { name: "ID d'étudiant", key: "studentId" },
        { name: t("common.firstName"), key: "firstname" },
        { name: t("common.lastName"), key: "lastname" },
      ];
      let data = [];
      let fileTitle = !!dataObject[0]?.title && slugify(`${dataObject[0]?.title}-${type}`) || 'form-answers-exported';

      dataObject?.map((el, indx) => {
        let stdVals = {};
        const stdAnswer = el?.answer?.[type];
        const stdAnswerList = !!stdAnswer && Object.values(stdAnswer?.data) || [];

        // std ID
        el?.student && (
          stdVals = { ...stdVals, studentId: getObjId(el?.student) }
        )
        // std name surname
        if (el?.studentData && el?.studentData?.length > 0) {
          stdVals = {
            ...stdVals,
            firstname: el?.studentData[0]?.description?.firstname,
            lastname: el?.studentData[0]?.description?.lastname,
          }
        }
        // render headers for answer
        stdAnswerList?.map((answer, aidx) => {
          headersArr.push({ name: `${answer['field-title']}`, key: `answer${aidx}` });
          if (answer['field-type'] != 'checkbox') {
            stdVals = { ...stdVals, [`answer${aidx}`]: answer[`${answer['field-type']}-answer`] }
          } else {
            if (Array.isArray(answer[`${answer['field-type']}-answer`])) {
              stdVals = { ...stdVals, [`answer${aidx}`]: answer[`${answer['field-type']}-answer`].join(';') }
            } else {
              stdVals = { ...stdVals, [`answer${aidx}`]: answer[`${answer['field-type']}-answer`] }
            }
          }
        });
        // recipient ID
        stdAnswer?.recipient && (
          stdVals = { ...stdVals, recipientId: getObjId(stdAnswer?.recipient) }
        )
        // Answer ID
        el?._ID && (
          stdVals = { ...stdVals, answerID: getObjId(el?._ID) }
        )
        // Communication ID
        el?._id && (
          stdVals = { ...stdVals, communicationId: getObjId(el?._id) }
        )
        // end
        !!stdAnswer && !!stdVals && Object.keys(stdVals)?.length > 0 && data.push(stdVals);
      });
      // add info in the end
      /*  headersArr = headersArr.concat([
        { name: "ID recipient", key: "recipientId" },
        { name: "ID de réponse", key: "answerID" },
        { name: "ID de communication", key: "communicationId" },
      ]) */

      const exportData = {
        headers: getUniqueArrayObj(headersArr, 'key'),
        items: data,
        fileTitle
      };

      return exportData;
    } else {
      return false;
    }
  }, [type]);

  const generatePlanObjecstFromData = useCallback((dataObject) => {
    if (dataObject && Array.isArray(dataObject) && dataObject?.length > 0) {
  
      const commData = dataObject?.[0]?.communicationData || dataObject?.[0]?.communication || {};
      let headersArr = [
        { name: t("common.firstName"), key: "firstname" },
        { name: t("common.lastName"), key: "lastname" },
      ];
      let appointmentsPlan = [];
      let data = [];
      let fileTitle = !!dataObject?.[0]?.title && slugify(`${dataObject?.[0]?.title}-${type}`) || 'form-answers-exported';

      if (!!commData?.appointmentsPlan?.plan) {
        appointmentsPlan = [...commData?.appointmentsPlan?.plan];
        appointmentsPlan = appointmentsPlan.sort((a, b) => {
          if ((a?.date < b?.date) && (a?.timeFrom < b?.timeFrom)) return -1;
          else if ((a?.date > b?.date) && (a?.timeFrom > b?.timeFrom)) return 1;
          return 0;
        });
      }

      dataObject?.map((el, indx) => {
        let stdVals = {};
        const stdAnswer = el?.answer?.[type];

        // std name surname
        if (el?.studentData && el?.studentData?.length > 0) {
          stdVals = {
            ...stdVals,
            firstname: el?.studentData[0]?.description?.firstname,
            lastname: el?.studentData[0]?.description?.lastname,
          }
        }
        // render headers for plan
        appointmentsPlan?.map((slotData, index) => {
          headersArr.push({ name: `${slotData?.slot['dateFormat']}`, key: `slot${index}` });
          if (getObjId(slotData?.student) == getObjId(el?.student)) {
            stdVals = { ...stdVals, [`slot${index}`]: slotData?.slot['timeString'] }
          } else {
            stdVals = { ...stdVals, [`slot${index}`]: '' }
          }

        });

        !!stdAnswer && !!stdVals && Object.keys(stdVals)?.length > 0 && data.push(stdVals);
      });

      const exportData = {
        headers: getUniqueArrayObj(headersArr, 'key'),
        items: data,
        fileTitle
      };

      return exportData;
    } else {
      return false;
    }
  }, [type]);
  const generatePlanObjecstFromDataAll = useCallback((dataObject) => {
    if (dataObject && Array.isArray(dataObject) && dataObject?.length > 0) {
  
      const commData = dataObject?.[0]?.communicationData || dataObject?.[0]?.communication || {};
      let headersArr = [
        { name: t("common.firstName"), key: "firstname" },
        { name: t("common.lastName"), key: "lastname" },
      ];
      let appointmentsPlan = [];
      let appointments = [];
      let data = [];
      let fileTitle = !!dataObject?.[0]?.title && slugify(`${dataObject?.[0]?.title}-${type}`) || 'form-answers-exported';

      if (!!commData?.appointmentsPlan?.plan) {
        appointmentsPlan = [...commData?.appointmentsPlan?.plan];
        appointmentsPlan = appointmentsPlan.sort((a, b) => {
          if ((a?.date < b?.date) && (a?.timeFrom < b?.timeFrom)) return -1;
          else if ((a?.date > b?.date) && (a?.timeFrom > b?.timeFrom)) return 1;
          return 0;
        });
      }

      let columns = [];
      if (!!commData?.appointments) {
        appointments = [...commData?.appointments?.["appointments-fields"]];
        appointments = appointments?.map((el, dateindx) => { 
          const date = el?.["field-date"];
          const formatDate = !!date && formatDateTimeValue(date, dateFormat);
          const timeSlot = el?.["field-input"];
          if (!!timeSlot && Array.isArray(timeSlot) && timeSlot?.length > 0) {
            timeSlot?.map((time, timeindx) => {
              const timeFrom = time?.[`time-from`],
                timeFromFormat =
                  !!timeFrom && formatDateTimeValue(timeFrom, timeFormat),
                timeTo = time?.[`time-to`],
                timeToFormat = !!timeTo && formatDateTimeValue(timeTo, timeFormat);
              const prepearSlot = `${timeFrom} - ${timeTo}`;
              (timeFrom && timeTo) && columns.push({
                index: dateindx,
                timeIndex: timeindx,
                date: date,
                dateFormat: formatDate,
                timeFrom,
                timeTo,
                timeFromFormat,
                timeToFormat,
                selected: false,
                reserved: false,
                prepearSlot,
                timeString: `${timeFromFormat} - ${timeToFormat}`,
              });
            });
          }
        });
        columns = columns.sort((a, b) => {
          if ((a?.date < b?.date) && (a?.timeFrom < b?.timeFrom)) return -1;
          else if ((a?.date > b?.date) && (a?.timeFrom > b?.timeFrom)) return 1;
          return 0;
        });
      }

      let rowIndex = 0;
      for (const row of dataObject) {
        let stdVals = {};
        // std name surname
        if (row?.studentData && row?.studentData?.length > 0) {
          stdVals = {
            ...stdVals,
            firstname: row?.studentData?.[0]?.description?.firstname,
            lastname: row?.studentData?.[0]?.description?.lastname,
          }
        }

        let slots = [];
        const stdAnswer = row?.answer?.[type];
        const stdAnswerList = (!!stdAnswer && Object.values(stdAnswer?.data)) || [];

        const colHeaders = columns?.map((timeSlot, slotInx) => {
          let { selected, ...restTimeSlot } = timeSlot;

          const hasAdminAnswer = appointmentsPlan?.find(
            adminAnswer =>
              getObjId(adminAnswer?.student) == getObjId(row?.student) &&
              adminAnswer?.slot?.date == timeSlot?.date &&
              adminAnswer?.slot?.timeFrom == timeSlot?.timeFrom &&
              adminAnswer?.slot?.timeTo == timeSlot?.timeTo,
          );

          let coreSlot = {
            ...restTimeSlot,
            chosen: !!hasAdminAnswer,
            reserved: false,
          };
          const findAnswer = stdAnswerList?.find(
            answ => answ?.["field-date"] == timeSlot?.date,
          );

          // check if we had answer on this date
          if (!!findAnswer) {
            const fieldAnswer = findAnswer[`${findAnswer["field-type"]}-answer`];

            // check if we had answer on this time
            if (findAnswer["field-type"] == "radio") {
              if (fieldAnswer == timeSlot?.prepearSlot) {
                const slot = {
                  ...coreSlot,
                  reserved: true,
                };

                const hasSlotIndex = slots.findIndex(
                  ss =>
                    ss?.date == timeSlot?.date &&
                    ss?.timeFrom == timeSlot?.timeFrom,
                );
                if (hasSlotIndex == -1) {
                  slots.push(slot);
                } else {
                  slots = slots?.map((el, ix) =>
                    ix == hasSlotIndex ? slot : el,
                  );
                }
              } else {
                const hasSlotIndex = slots.findIndex(
                  ss =>
                    ss?.date == timeSlot?.date &&
                    ss?.timeFrom == timeSlot?.timeFrom,
                );
                if (hasSlotIndex == -1) {
                  slots.push(coreSlot);
                } else {
                  slots = slots?.map((el, ix) =>
                    ix == hasSlotIndex ? coreSlot : el,
                  );
                }
              }
            } else if (
              findAnswer["field-type"] == "checkbox" &&
              Array.isArray(fieldAnswer)
            ) {
              // check if we had answer on this time array
              if (fieldAnswer?.length > 0) {

                for(const filed of fieldAnswer) {
                  const hasSlotIndex = slots.findIndex(
                    ss => `${ss?.timeFrom} - ${ss?.timeTo}` == timeSlot?.prepearSlot,
                  );
                  if (filed == timeSlot?.prepearSlot) {
                    const slot = {
                      ...coreSlot,
                      reserved: true,
                    };
                    if (hasSlotIndex == -1) {
                      slots.push(slot);
                    } else {
                      slots = slots?.map((el, ix) =>
                        ix == hasSlotIndex ? slot : el,
                      );
                    }
                  } else {
                    if (hasSlotIndex == -1) {
                      slots.push(coreSlot);
                    }
                  }
                }

              } else {
                const hasSlotIndex = slots.findIndex(
                  ss =>
                    ss?.date == timeSlot?.date &&
                    ss?.timeFrom == timeSlot?.timeFrom,
                );

                if (hasSlotIndex == -1) {
                  slots.push(coreSlot);
                } 
              }
            } else {
              const hasSlotIndex = slots.findIndex(
                ss =>
                  ss?.date == timeSlot?.date &&
                  ss?.timeFrom == timeSlot?.timeFrom,
              );
              if (hasSlotIndex == -1) {
                slots.push(coreSlot);
              }
            }
          } else {
            const hasSlotIndex = slots.findIndex(
              ss =>
                ss?.date == timeSlot?.date &&
                ss?.timeFrom == timeSlot?.timeFrom,
            );

            if (hasSlotIndex == -1) {
              slots.push(coreSlot);
            }
          }

          return {
            ...timeSlot,
            selected: !!hasAdminAnswer
          };
        });
        columns = colHeaders;

        // render body for plan
        slots?.map((sl, index) => {
          if (!!sl?.chosen) {
            stdVals = { ...stdVals, [`slot${index}`]: t("common.confirmed") } // confirmed
          } else if (!!sl?.reserved) {
            stdVals = { ...stdVals, [`slot${index}`]: t("common.available") } // available
          } else {
            stdVals = { ...stdVals, [`slot${index}`]: t("common.unavailable") } // not available
          }
        });

        Object.keys(stdVals)?.length > 0 && data.push(stdVals);

        rowIndex++;
      }

      // render headers for plan
      columns?.map((slotData, index) => {
        headersArr.push({ name: `${slotData?.dateFormat}, ${slotData?.timeString}`, key: `slot${index}` });
      });

      const exportData = {
        headers: getUniqueArrayObj(headersArr, 'key'),
        items: data,
        fileTitle
      };

      return exportData;
    } else {
      return false;
    }
  }, [type]);

  useEffect(() => {
    let data = null;
    if (type == 'forms') {
      data = generateFormsObjecstFromData(attachmentData);
    } else if (type == 'appointments') {
      data = generatePlanObjecstFromDataAll(attachmentData);
    }
    !!data && setCsvReport(data);
  }, [attachmentData, type]);

  const handleExportCsv = useCallback(() => {
    const csvData = [];
    const headers = csvReport.headers.map((header) => header.name);
    csvData.push(headers);
    csvReport.items.forEach((item) => {
      const rowData = csvReport.headers.map((header) => item[header.key]);
      csvData.push(rowData);
    });
    const csv = Papa.unparse(csvData);
    // INFO: Excel (at least my version) needs the Byte Order Mark (BOM) to properly display UTF-8 content from a CSV file. You can achieve this by prepending the content with the \uFEFF unicode character in JavaScript.
    const BOM = "\uFEFF";
    const csvDataForSave = BOM + csv;
    const blob = new Blob([csvDataForSave], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, `${csvReport.fileTitle}.csv`);
  }, [csvReport]);

  return csvReport && (
    <div {...rest} className={childClassNames}>
      <Button
        onClick={handleExportCsv}
        className={`tcf-fb-export-button__button ${type}`}
      >
        {!!btnName && btnName || t("news.exportResults")}
      </Button>
    </div>
  );
}

FBExportButton.defaultProps = {
  type: 'forms'
};
FBExportButton.propTypes = {
  type: PropTypes.oneOf(['appointments', 'forms']).isRequired,
  attachmentData: PropTypes.oneOfType([PropTypes.bool, PropTypes.array, PropTypes.object]),
};

export default memo(FBExportButton);
